import { render, staticRenderFns } from "./activeUserDatainGroupsChartBox.vue?vue&type=template&id=1db2b622&"
import script from "./activeUserDatainGroupsChartBox.vue?vue&type=script&lang=js&"
export * from "./activeUserDatainGroupsChartBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports